module.exports = __webpack_public_path__ + "img/top5.14a22f78.png";